/**
 * 数据可视化大屏API接口
 * @author AI Assistant
 * @description 提供可视化大屏所需的所有数据接口
 */

import request from '@/utils/request'

/**
 * 获取桥梁完整可视化数据
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: Object}>} 完整可视化数据
 */
export function getBridgeVisualizationData(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}`,
    method: 'get'
  })
}

/**
 * 获取船舶类型统计
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: Array<{vesselType: number, vesselTypeName: string, count: number, percentage: number}>}>} 船舶类型统计数据
 */
export function getVesselTypeStats(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/vessel-type-stats`,
    method: 'get'
  })
}

/**
 * 获取预警统计
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: {todayCount: number, thisMonthCount: number, thisYearCount: number}}>} 预警统计数据
 */
export function getAlertStats(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/alert-stats`,
    method: 'get'
  })
}

/**
 * 获取预警类型统计
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: Array<{alertType: string, alertTypeName: string, count: number, percentage: number}>}>} 预警类型统计数据
 */
export function getAlertTypeStats(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/alert-type-stats`,
    method: 'get'
  })
}

/**
 * 获取流量统计
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: Array<{hour: number, timeLabel: string, count: number}>}>} 流量统计数据
 */
export function getTrafficStats(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/traffic-stats`,
    method: 'get'
  })
}

/**
 * 获取设备状态统计
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: {totalCount: number, onlineCount: number, offlineCount: number}}>} 设备状态统计数据
 */
export function getDeviceStats(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/device-stats`,
    method: 'get'
  })
}

/**
 * 获取水文气象数据
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: {waterLevel: number, visibility: number, windSpeed: number, windDirection: string}}>} 水文气象数据
 */
export function getWeatherData(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/weather-data`,
    method: 'get'
  })
}

/**
 * 获取最新预警信息
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: Array<{time: string, alertType: string, message: string}>}>} 最新预警信息
 */
export function getLatestAlerts(bridgeId) {
  return request({
    url: `/visualization/bridge/${bridgeId}/latest-alerts`,
    method: 'get'
  })
}
